module.exports = __webpack_public_path__ + "assets/a72a8a040630cdb7ba11db1a2704280f.mp3";